import colors from 'src/assets/stylesheets/colors.scss'

export const tabBarStyle = {
  paddingLeft: 20,
}

export const modalIconStyle = {
  color: colors.red_7,
}
